module.exports = __webpack_public_path__ + "img/home_05.c9177ca0.png";